var openPostWindow  = function(url, windowoption, name, params){
        var form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", url);
            form.setAttribute("target", "view");

            for (var i in params) {
                if (params.hasOwnProperty(i)) {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = i;
                    input.value = params[i];
                    form.appendChild(input);
                }
            }
            
            document.body.appendChild(form);

            window.open('', 'view');
            
            form.submit();
            
            document.body.removeChild(form);
    }

export default openPostWindow;


// WEBPACK FOOTER //
// ./app/open-window-with-post.js